function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "110mm",
    height: "40mm",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    viewBox: "0 0 11000 4000",
    id: "svg10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "m 10377.659,2309.5987 c 0,-428.61 -347.46,-779.04 -776.0697,-779.04 -428.61,0 -776.07,347.46 -776.07,776.07 0,428.61 347.46,776.07 776.07,776.07 111.9,0 218.31,-23.7 314.37,-66.3 v -359.82 c -84.18,77.73 -196.71,125.25 -320.31,125.25 -260.82,0 -472.26,-211.44 -472.26,-472.23 0,-260.82 211.44,-472.26 472.26,-472.26 260.79,0 473.7297,211.44 473.7297,472.26 v 627.15 c 0,41.31 15.03,78.42 44.28,107.64 29.22,29.25 66.33,44.28 107.64,44.28 41.34,0 82.8,-16.2 112.05,-45.45 29.25,-29.22 44.25,-66.33 44.25,-107.64 z",
    id: "path2",
    style: {
      clipRule: "evenodd",
      fill: "#2295a4",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "m 7895.7293,2299.2487 c 0,-102.99 19.35,-203.01 59.67,-297.78 39.06,-91.89 93.63,-174.3 163.68,-245.43 69.9,-70.98 151.2,-126.72 242.37,-166.98 93.81,-41.46 193.26,-62.31 297.03,-64.41 43.68,0 84.78,12.72 116.85,43.11 30.69,29.07 46.92,66.54 46.92,108.81 0,42.27 -16.23,79.74 -46.92,108.78 -32.07,30.39 -73.17,43.14 -115.17,43.11 -62.19,1.74 -121.92,14.97 -178.53,40.65 -55.44,25.11 -105.36,58.89 -148.41,101.91 -42.6,42.63 -75.06,92.46 -98.19,148.11 -23.91,57.57 -35.46,117.78 -35.46,180.12 v 634.53 c 0,41.34 -15,78.39 -44.25,107.64 -29.25,29.25 -66.33,44.28 -107.67,44.28 -41.31,0 -78.42,-15.03 -107.64,-44.28 -29.25,-29.25 -44.28,-66.3 -44.28,-107.64 z",
    id: "path3",
    style: {
      clipRule: "evenodd",
      fill: "#2295a4",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "m 7651.9193,2309.5987 c 0,-428.61 -347.46,-779.04 -776.0698,-779.04 -428.61,0 -776.07,347.46 -776.07,776.07 0,428.61 347.46,776.07 776.07,776.07 111.9,0 218.31,-23.7 314.37,-66.3 v -359.82 c -84.18,77.73 -196.71,125.25 -320.31,125.25 -260.82,0 -472.26,-211.44 -472.26,-472.23 0,-260.82 211.44,-472.26 472.26,-472.26 260.79,0 473.7298,211.44 473.7298,472.26 v 627.15 c 0,41.31 15.03,78.42 44.28,107.64 29.22,29.25 66.33,44.28 107.64,44.28 41.34,0 82.8,-16.2 112.05,-45.45 29.25,-29.22 44.25,-66.33 44.25,-107.64 z",
    id: "path4",
    style: {
      clipRule: "evenodd",
      fill: "#2295a4",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "m 6084.1795,2933.7787 c 0,41.34 -15.03,78.39 -44.28,107.64 -29.22,29.25 -66.33,44.28 -108.96,44.28 -88.17,-1.92 -177.81,-17.97 -255.87,-60.75 -64.89,-35.61 -122.52,-81.72 -168.18,-140.25 -41.43,-53.13 -73.53,-112.05 -93.15,-176.64 -16.17,-53.25 -27.78,-109.83 -27.78,-165.69 v -1343.19 c 0,-41.34 15.03,-78.42 44.28,-107.67 29.22,-29.25 66.33,-44.25 107.64,-44.25 41.34,0 78.42,15 107.67,44.25 29.25,29.25 44.25,66.33 44.25,107.67 v 1343.19 c 0,17.58 5.25,41.22 9,58.38 6.06,27.75 19.41,54.33 34.74,78.06 18.87,29.13 45.33,52.41 74.25,71.22 36.03,23.43 84.18,30.57 124.47,31.83 41.31,0 78.42,15.03 107.64,44.28 29.25,29.25 44.28,66.3 44.28,107.64 z",
    id: "path5",
    style: {
      clipRule: "evenodd",
      fill: "#2295a4",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "m 4202.2495,2917.6087 c -39.87,42.3 -86.1,77.61 -138.15,105.93 -78.69,42.81 -164.58,62.16 -254.01,62.16 -73.98,0 -145.77,-14.1 -213.63,-43.5 -64.59,-27.99 -122.94,-66.6 -172.74,-116.4 -49.89,-49.86 -88.14,-108.45 -115.26,-173.55 -28.26,-67.8 -41.7,-139.38 -41.7,-212.82 v -859.89 c 0,-41.34 15.03,-78.42 44.28,-107.67 29.22,-29.25 66.33,-44.25 107.64,-44.25 41.34,0 78.42,15 107.67,44.25 29.25,29.25 44.25,66.33 44.25,107.67 v 859.89 c 0,32.37 5.97,63.6 18.81,93.3 12.63,29.22 29.76,55.62 51.87,78.54 21.57,22.38 46.95,39.45 75.51,51.78 29.7,12.87 60.93,18.81 93.3,18.81 65.67,0 120.18,-22.74 166.98,-68.76 49.38,-48.54 72.36,-106.8 75.48,-174.36 l -0.03,-859.2 c 0,-41.34 15.03,-78.42 44.28,-107.67 29.22,-29.25 66.33,-44.25 107.64,-44.25 41.34,0 78.42,15 107.67,44.25 29.25,29.25 44.25,66.33 44.25,107.67 v 859.89 c 0,32.37 5.97,63.6 18.81,93.3 12.63,29.22 29.76,55.62 51.87,78.54 21.57,22.38 46.95,39.45 75.51,51.78 29.7,12.87 60.93,18.81 93.3,18.81 32.37,0 63.6,-5.94 93.3,-18.81 29.25,-12.63 55.26,-30.06 77.76,-52.56 22.53,-22.53 39.96,-48.51 52.59,-77.76 12.87,-29.7 18.78,-60.96 18.78,-93.3 v -859.89 c 0,-41.34 15.03,-78.42 44.28,-107.67 29.22,-29.25 66.33,-44.25 107.64,-44.25 41.34,0 78.42,15 107.67,44.25 29.25,29.25 44.25,66.33 44.25,107.67 v 859.89 c 0,73.95 -14.1,145.74 -43.5,213.6 -27.99,64.62 -66.57,122.97 -116.4,172.77 -49.8,49.8 -108.18,88.41 -172.77,116.4 -67.83,29.4 -139.65,43.5 -213.6,43.5 -89.43,0 -175.35,-19.35 -254.04,-62.16 -52.29,-28.47 -98.91,-63.84 -139.56,-105.93 z",
    id: "path6",
    style: {
      clipRule: "evenodd",
      fill: "#2295a4",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "m 1997.1295,2730.3787 c -431.34,0 -846.21,-312.39 -846.21,-766.26 0,-293.19 181.41,-543.27 439.17,-671.85 146.19,-72.93 399.69,-206.67 563.1,-218.43 93.9,-6.75 344.88,-21.78 386.76,97.59 20.88,59.61 12.21,103.98 6.54,165.63 -13.02,141.27 -3.36,257.31 50.19,390.87 41.4,103.35 111.42,213.99 142.68,316.38 38.16,125.04 23.28,224.37 -31.53,342.57 -115.02,248.04 -460.53,343.5 -710.7,343.5 z m 0,300 c 417.21,0 827.55,-182.4 982.86,-517.29 101.49,-218.88 95.79,-394.32 46.29,-556.38 -35.58,-116.61 -103.65,-221.91 -151.14,-340.38 -86.22,-215.16 27.78,-316.44 -52.11,-544.2 -92.94,-265.01995 -378.48,-319.97995 -691.35,-297.50995 -224.61,16.14 -514.38,168.84 -675.51,249.20995 -360.24,179.7 -605.24996,533.4 -605.24996,940.29 0,588.87 513.17996,1066.26 1146.20996,1066.26 z",
    id: "path7",
    style: {
      clipRule: "evenodd",
      fill: "#2295a4",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextLogo);
export default __webpack_public_path__ + "static/media/text-logo.8cd232adfe9162ba5e106aadf26b1947.svg";
export { ForwardRef as ReactComponent };